import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../config/apiConfig";
import apiClient from '../services/api/apiClient';
import { Episode } from "../types/episode";

const fetchListEpisodes = async (type: string, idPost: string, page: number = 1): Promise<{ data: Episode[]; isNext: boolean; paged: number }> => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.LIST_EPISODE}${type}/${idPost}/paged/${page}/`
    );
    return {
      data: response.data.data,
      isNext: response.data.is_next,
      paged: response.data.paged,
    };
  } catch (error) {
    console.error("Error fetching episodes:", error);
    return { data: [], isNext: false, paged: page };
  }
};

export const useEpisodes = (type: string, idPost: string, slug: string, page: number = 1) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [`listchapter${type}${idPost}${slug}`, page],
    queryFn: async () => {
      const { data, isNext, paged } = await fetchListEpisodes(type, idPost, page);
      return { episodes: data, isNext, paged };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    episodes: data?.episodes || [],
    isLoading,
    hasNextPage: data?.isNext || false,
    page: data?.paged || page,
    refetch
  };
};